var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 68,
    viewBox: "0 0 71 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7349 7.04144C28.8398 7.04144 39.2125 0.0585938 46.4909 0.0585938C53.7692 0.0585938 69.0554 3.79265 69.0554 33.6768C69.0554 63.5609 48.4912 67.944 40.4856 67.944C2.99751 67.944 -13.0158 7.04144 13.7349 7.04144Z",
    fill: "url(#paint0_linear_388_3888)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2492 53.7334L9.64214 52.1263L6.42802 55.3405L8.03509 56.9475L11.2492 53.7334Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8436 46.0996L7.62951 42.8855L6.02245 44.4925L9.23657 47.7067L10.8436 46.0996Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0865 55.3408L16.8724 52.1267L15.2653 53.7338L18.4794 56.9479L20.0865 55.3408Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1665 19.699C60.2869 19.699 58.7574 18.1695 58.7574 16.2899C58.7574 14.4104 60.2869 12.8809 62.1665 12.8809C64.046 12.8809 65.5756 14.4104 65.5756 16.2899C65.5756 18.1695 64.046 19.699 62.1665 19.699ZM62.1665 15.1536C61.5415 15.1536 61.0301 15.6627 61.0301 16.2899C61.0301 16.9172 61.5415 17.4263 62.1665 17.4263C62.7915 17.4263 63.3028 16.9172 63.3028 16.2899C63.3028 15.6627 62.7937 15.1536 62.1665 15.1536Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1904 33.4082V14.2236C27.2809 19.4094 40.1012 16.3843 44.75 14.2236V33.4082C29.7691 42.2606 17.4682 37.0967 13.1904 33.4082Z",
    fill: "#A1AAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.565 38.0578V16.8435C16.765 16.8435 13.4301 14.3118 12.8626 13.0459V31.6412C15.3769 38.5555 22.3785 38.7999 25.565 38.0578Z",
    fill: "#7B87FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9326 17.7748C38.5889 17.7748 46.4168 15.0753 46.4168 11.7453C46.4168 8.41533 38.5889 5.71582 28.9326 5.71582C19.2763 5.71582 11.4484 8.41533 11.4484 11.7453C11.4484 15.0753 19.2763 17.7748 28.9326 17.7748Z",
    fill: "#A1AAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3848 15.9093C21.5376 12.6046 23.7818 8.94236 25.3848 7.52432C22.4693 7.16849 16.0139 7.36818 13.5167 11.0136C11.0194 14.659 20.3882 15.7963 25.3848 15.9093Z",
    fill: "#7B87FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9329 19.028C20.1451 19.028 11.2491 16.5273 11.2491 11.7464C11.2491 6.96554 20.1451 4.46484 28.9329 4.46484C37.7207 4.46484 46.6167 6.96554 46.6167 11.7464C46.6167 16.5273 37.7207 19.028 28.9329 19.028ZM28.9329 7.58551C19.5106 7.58551 14.3698 10.3338 14.3698 11.7464C14.3698 13.159 19.5106 15.9073 28.9329 15.9073C38.3553 15.9073 43.496 13.159 43.496 11.7464C43.496 10.3338 38.3553 7.58551 28.9329 7.58551Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9329 29.43C20.1451 29.43 11.2491 26.9293 11.2491 22.1484H14.3698C14.3698 23.5611 19.5106 26.3093 28.9329 26.3093C30.358 26.3093 31.8019 26.2344 33.2249 26.0888L33.5411 29.1928C32.0141 29.3509 30.4621 29.43 28.9329 29.43Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4738 39.8333H28.9329C20.1451 39.8333 11.2491 37.3326 11.2491 32.5518H14.3698C14.3698 33.9644 19.5106 36.7126 28.9329 36.7126H29.4738V39.8333Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2491 11.7451H14.3698V32.5496H11.2491V11.7451Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4963 11.7451H46.617V22.6883H43.4963V11.7451Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5335 37.2607C57.5335 44.5574 51.6183 50.4726 44.3216 50.4726C37.0249 50.4726 31.1097 44.5574 31.1097 37.2607C31.1097 29.964 37.0249 24.0488 44.3216 24.0488C51.6183 24.0488 57.5335 29.964 57.5335 37.2607Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9972 46.4638V50.4719H70.7438V43.1477C70.7438 42.3896 70.1286 41.7744 69.3705 41.7744H62.0463V44.521H66.0545L55.1799 55.3957L48.8261 49.0419C48.3738 48.5878 47.6689 48.5072 47.125 48.8496L27.4412 61.2093L28.9023 63.5365L47.6597 51.7592L54.2094 58.3089C54.7459 58.8454 55.6156 58.8454 56.1521 58.3089L67.9972 46.4638Z",
    fill: "#433ED1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2704 51.5944C32.4128 49.1866 28.6299 43.5341 28.6299 37.1968C28.6299 28.6146 35.6117 21.6328 44.1939 21.6328C52.776 21.6328 59.7579 28.6146 59.7579 37.1968C59.7579 41.9777 57.6137 46.4198 53.8728 49.3861L52.1645 47.2347C55.2461 44.792 57.0113 41.1336 57.0113 37.1968C57.0113 30.1289 51.2618 24.3794 44.1939 24.3794C37.126 24.3794 31.3765 30.1289 31.3765 37.1968C31.3765 42.4171 34.4929 47.0717 39.3141 49.0566L38.2704 51.5944Z",
    fill: "#433ED1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2298 40.6746C46.5907 40.6746 48.5046 38.7608 48.5046 36.3999C48.5046 34.039 46.5907 32.1251 44.2298 32.1251C41.8689 32.1251 39.955 34.039 39.955 36.3999C39.955 38.7608 41.8689 40.6746 44.2298 40.6746ZM44.2298 43.8964C48.3701 43.8964 51.7264 40.5401 51.7264 36.3999C51.7264 32.2596 48.3701 28.9033 44.2298 28.9033C40.0896 28.9033 36.7333 32.2596 36.7333 36.3999C36.7333 40.5401 40.0896 43.8964 44.2298 43.8964Z",
    fill: "#433ED1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8388 44.424L44.4531 39.5599L46.6125 37.169L51.9982 42.0331L49.8388 44.424Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_3888",
    x1: 34.749,
    y1: 0.0585938,
    x2: 34.749,
    y2: 67.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk3);
export default __webpack_public_path__ + "static/media/uwalk3.9e806ae73c091f94446d93794abac456.svg";
export { ForwardRef as ReactComponent };